<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-hotel-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
      [checkId]="checkId"></app-hotel-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} hotel
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>) - campos web (<i
              class="fab fa-quinscape text-primary"></i>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Nombre hotel<span class="required"></span></label>
                  <input type="text" id="item_tradename" formControlName="tradename" required="true"
                    class="form-control" [autofocus]
                    [ngClass]="{'parsley-error': (submitted && f['tradename'].errors)}">
                  <div *ngIf="submitted && f['tradename'].errors">
                    <small class="text-danger" *ngIf="f['tradename'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['tradename'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Ciudad turística<span class="required"></span></label>
                  <select class="form-control" id="citieTouristicSelected" formControlName="citietouristic_id" required>
                    <option [ngValue]="null">Seleccionar opción</option>
                    <option *ngFor="let item of citiestouristic" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['citietouristic_id'].errors">
                    <small class="text-danger" *ngIf="f['citietouristic_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label><i class="fab fa-quinscape text-primary m-r-5"></i>Tipo Hotel<span
                      class="required"></span></label>
                  <select class="form-control" id="typeHotelSelected" formControlName="typehotel_id" required>
                    <option [ngValue]="null">Seleccionar opción</option>
                    <option *ngFor="let item of typeshotel" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['typehotel_id'].errors">
                    <small class="text-danger" *ngIf="f['typehotel_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Categoría estrella</label>
                  <select class="form-control" id="categorySelected" formControlName="category">
                    <option *ngFor="let item of categoriesstars" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>N° RUC</label>
                  <input type="text" id="item_document" class="form-control" formControlName="document">
                </div>
                <div class="form-group col-lg-6">
                  <label>Razón social</label>
                  <input type="text" id="item_fullname" class="form-control" formControlName="fullname">
                </div>
                <div class="form-group col-lg-3">
                  <label>Celular</label>
                  <input type="text" class="form-control" formControlName="cellphone">
                </div>
                <div class="form-group col-lg-3">
                  <label>Teléfono fijo</label>
                  <input type="text" class="form-control" formControlName="telephone">
                </div>
                <div class="form-group col-lg-6">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-6">
                  <label>Dirección</label>
                  <textarea rows="1" class="form-control no-resize" formControlName="address"></textarea>
                </div>
                <div class="form-group col-lg-2">
                  <label>CHECK-IN</label>
                  <input type="time" class="form-control" formControlName="checkin">
                </div>
                <div class="form-group col-lg-2">
                  <label>CHECK-OUT</label>
                  <input type="time" class="form-control" formControlName="checkout">
                </div>
                <div class="form-group col-lg-2">
                  <div class="custom-control custom-checkbox m-t-25">
                    <input type="checkbox" id="is_top_web" class="custom-control-input" formControlName="is_top_web">
                    <label class="custom-control-label p-t-3" for="is_top_web">
                      <i class="fab fa-quinscape text-primary m-r-5"></i> Es top
                      <span data-toggle="tooltip" data-placement="right"
                        data-original-title="El hotel destaca como top en la web"><i
                          class="fas fa-info-circle f-s-14"></i></span>
                    </label>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label>Seleccionar Formato PDF </label>
                  <ng-container *ngIf="item.value.url_file != null">
                    <div class="row col-lg-12 col-12 p-0">
                      <div class="col-lg-4 col-6">
                        <a target="_blank" href="tenants/{{item.value.url_file}}"
                          class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                            class="far fa-file-pdf m-l-5"></i></a>
                      </div>
                      <div class="form-group col-lg-2 col-6">
                        <button (click)="removeFilePdf()" class="btn btn-outline-danger pointer w-100">
                          Quitar pdf <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.value.url_file == null">
                    <input id="file_pdf" type="file" (change)="onFileSelected($event)" accept="application/pdf" />
                  </ng-container>
                </div>
              </div>

              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i>Tarifas del hotel
                    (habitación)
                  </p>
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-lg-3">
                      <label>
                        <i class="fas fa-info-circle m-r-5" data-toggle="tooltip" data-placement="right"
                          data-original-title="Precio referencial para paquetes por internet"></i>Tarifa x persona en
                        paquete
                      </label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">S/</div>
                        </div>
                        <input type="text" class="form-control" formControlName="price_package" numeric decimals="2"
                          onclick="click_input(this)">
                      </div>
                    </div>
                    <div class="form-group col-lg-6">
                      <!-- <div class="input-group">
                        <label>
                          <i class="fas fa-info-circle m-r-5" data-toggle="tooltip" data-placement="right"
                            data-original-title="Precios de las habitaciones del hotel"></i>
                          Seleccione Habitación
                        </label>
                        <div class="input-group">
                          <select class="form-control" id="typeBedroomSelected" [(ngModel)]="typeBedroomSelected"
                            [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let item of typesbedroom" [value]="item.id">{{ item.description }}</option>
                          </select>
                          <div class="input-group-append">
                            <a class="btn btn-info f-s-12 text-white" (click)="addDetailTypesBedroom()">Agregar <i
                                class="fas fa-arrow-down m-l-5"></i></a>
                          </div>
                        </div>                         
                      </div>-->
                    </div>

                    <div class="form-group col-lg-12">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0 table-sm">
                          <thead class="thead-default">
                            <tr>
                              <th>#</th>
                              <th class="nowrap w-25 w-xs-auto">Habitación</th>
                              <th class="nowrap w-xs-auto">N° huesp.</th>
                              <th class="nowrap text-center w-15 w-xs-auto">Precio Corporativo</th>
                              <th class="nowrap text-center w-15 w-xs-auto">Precio Normal</th>
                              <th class="nowrap text-center w-15 w-xs-auto">Precio Temp. Alta</th>
                              <th class="text-left">Observación</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody formArrayName="detail_typesbedroom">
                            <ng-container *ngIf="getDetailTypesBedroom().length == 0">
                              <td colspan="4"><span>No se encontraron registros</span></td>
                            </ng-container>
                            <ng-container *ngIf="getDetailTypesBedroom().length > 0">
                              <tr *ngFor="let item of getDetailTypesBedroom(); let _index = index">
                                <ng-container [formGroupName]="_index">
                                  <td>-</td>
                                  <td class="nowrap w-25 w-xs-auto">
                                    <input type="text" id="typebedroom_description{{_index}}"
                                      class="form-control form-control-xs text-left" formControlName="description">
                                  </td>
                                  <td class="w-10 w-xs-auto">
                                    <input type="text" id="typebedroom_number_guests{{_index}}"
                                      class="form-control form-control-xs text-center bold"
                                      formControlName="number_guests" numeric onclick="click_input(this)">
                                  </td>
                                  <td class="w-15 w-xs-auto">
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text f-s-11">S/ <span
                                            class="required m-l-15"></span></span>
                                      </div>
                                      <input type="text" id="typebedroom_price_corporate{{_index}}"
                                        class="form-control form-control-xs text-center bold"
                                        formControlName="price_corporate" numeric decimals="2"
                                        onclick="click_input(this)">
                                    </div>
                                  </td>
                                  <td class="w-15 w-xs-auto">
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text f-s-11">S/ <span
                                            class="required m-l-15"></span></span>
                                      </div>
                                      <input type="text" id="typebedroom_price_sale{{_index}}"
                                        class="form-control form-control-xs text-center bold"
                                        formControlName="price_sale" numeric decimals="2" onclick="click_input(this)">
                                    </div>
                                  </td>
                                  <td class="w-15 w-xs-auto">
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text f-s-11">S/</span>
                                      </div>
                                      <input type="text" id="typebedroom_price_high{{_index}}"
                                        class="form-control form-control-xs text-center bold"
                                        formControlName="price_high" numeric decimals="2" onclick="click_input(this)">
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-group">
                                      <input type="text" id="typebedroom_observation{{_index}}"
                                        class="form-control form-control-xs text-left" formControlName="observation">
                                    </div>
                                  </td>
                                  <td>
                                    <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                      (click)="removeDetailTypeBedroom(_index)"></i>
                                  </td>
                                </ng-container>
                              </tr>
                            </ng-container>
                            <!-- <ng-container *ngIf="detail_typesbedroom.length == 0">
                              <td colspan="2"><span>No se encontraron registros</span></td>
                            </ng-container>
                            <ng-container *ngIf="detail_typesbedroom.length > 0">
                              <tr *ngFor="let item of detail_typesbedroom; let index_ = index">
                                <td>-</td>
                                <td class="nowrap w-xs-auto">{{item.description}}</td>
                                <td class="w-30 w-xs-auto">
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text f-s-11">S/ <span
                                          class="required m-l-15"></span></span>
                                    </div>
                                    <input type="text" id="typebedroom_price_sale{{index_}}"
                                      class="form-control form-control-xs text-center bold" (input)="item.price_sale"
                                      (keyup)="changePriceNormalTypeBedroom($event.target, index_)" numeric decimals="2"
                                      onclick="click_input(this)">
                                  </div>
                                </td>
                                <td class="w-30 w-xs-auto">
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text f-s-11">S/ <span
                                          class="required m-l-15"></span></span>
                                    </div>
                                    <input type="text" id="typebedroom_price_corporate{{index_}}"
                                      class="form-control form-control-xs text-center bold"
                                      (keyup)="changePriceCorporateTypeBedroom($event.target, index_)" numeric
                                      decimals="2" onclick="click_input(this)">
                                  </div>
                                </td>
                                <td>
                                  <div class="input-group">
                                    <input type="text" id="typebedroom_observation{{index_}}"
                                      class="form-control form-control-xs text-left"
                                      (keyup)="changeObservationTypeBedroom($event.target, index_)">
                                  </div>
                                </td>
                                <td>
                                  <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                    (click)="removeTypeBedroom(item.id, index_)"></i>
                                </td>
                              </tr>                              
                            </ng-container> -->
                          </tbody>
                        </table>
                      </div>
                      <a class="btn btn-info btn-sm f-s-12 text-white m-t-10" (click)="addDetailTypesBedroom()">Agregar
                        Hab. <i class="fas fa-arrow-up m-l-5"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i>Otros datos (página
                    web)
                  </p>
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-lg-12 m-t-10 m-b-15">
                      <label><i class="fab fa-quinscape text-primary m-r-5"></i>Descripción hotel (Ubicación,
                        servicios, etc)</label>
                      <ckeditor formControlName="description"></ckeditor>
                    </div>
                    <div class="form-group col-lg-12">
                      <label><i class="fab fa-quinscape text-primary m-r-5"></i>Iframe google maps (ubicación: <a
                          target="_blank" class="text-primary"
                          href="https://www.mapsdirections.info/crear-un-mapa-de-google/">Click enlace generar</a>)
                        <i class="fas fa-info-circle m-l-20" data-toggle="tooltip" data-placement="right"
                          data-original-title="Copiar y pegar aquí el código de iFrame generado"></i>
                      </label>
                      <textarea class="form-control no-resize" rows="2" formControlName="iframe_map"></textarea>
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Link web <i class="fas fa-external-link-square-alt m-l-5"></i></label>
                      <input type="text" class="form-control" formControlName="link_external_web">
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Link Video<i class="fas fa-video m-l-5"></i></label>
                      <input type="text" class="form-control" formControlName="link_external_video">
                    </div>
                    <!-- <div class="form-group col-lg-5">
                      <label class="d-inline" style="width: auto;">
                        <i class="fab fa-quinscape text-primary m-r-5"></i>Servicios de hotel                        
                      </label>
                      <button type="button" data-toggle="modal" data-target="#openExtendsServiceHotel"
                          (click)="ServicehotelExtendsComponent.focused()"
                          class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                        </button>
                      <div class="input-group">
                        <select class="form-control" id="serviceHotelSelected" [(ngModel)]="serviceHotelSelected"
                          [ngModelOptions]="{standalone: true}">
                          <option *ngFor="let item of serviceshotel" [value]="item.id">{{ item.description }}</option>
                        </select>
                        <div class="input-group-append">
                          <a type="button" class="btn btn-info f-s-12 text-white" (click)="addServiceHotel()">Agregar<i
                              class="fas fa-arrow-down m-l-5"></i></a>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-12 m-t-10">
                      <ul style="list-style: circle;" class="p-l-5">
                        <li class="d-inline-block m-r-20 m-b-15"
                          *ngFor="let item of detail_serviceshotel; let index_ = index">
                          <i class="fas fa-dot-circle f-s-10 m-r-3"></i>
                          {{item.description}}
                          <i class="far fa-trash-alt pointer f-s-15 text-danger m-l-2"
                            (click)="removeServiceHotel(item.id, index_)">
                          </i> |
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i>Servicios hotel
                    <button type="button" data-toggle="modal" data-target="#openExtendsServiceHotelList"
                      (click)="ServicehotelListComponent.list()"
                      class="btn btn-light btn-extends m-l-10"><i class="fa fa-cogs m-r-5"></i>Config.
                    </button>
                    <button type="button" data-toggle="modal" data-target="#openExtendsServiceHotel"
                      (click)="ServicehotelExtendsComponent.focused()"
                      class="btn btn-outline-info btn-extends m-l-10"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button>
                  </p>
                </div>
                <div class="col-lg-12 m-t-10">
                  <ul style="list-style: none;" class="p-l-5">
                    <li class="d-inline-block m-r-20 m-b-20" *ngFor="let item of serviceshotel; let i = index">
                      <div class="d-flex align-items-center" style="gap: 5px;">
                        <input type="checkbox" [checked]="isSelectedService(item.id)" (change)="toggleService(item)"
                          id="{{item.id}}" style="height: 16px; width: 20px; margin: 0; cursor: pointer;" />
                        <label class="m-0" style="cursor: pointer;" for="{{item.id}}">
                          {{ item.description }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  Guardar
                  <ng-container *ngIf="isEdit">
                    Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-servicehotel-extends (onSubmitEvent)="extendsServiceHotel($event)"></app-servicehotel-extends>
<app-servicehotel-list (onSubmitEvent)="extendsServiceHotelList($event)"></app-servicehotel-list>
